<div *ngIf="show" class="flex items-start space-x-1 text-negative">
  <parkour-icon name="alert-triangle" class="flex mt-[0.125rem]"/>
  <p class="typo-body variant-body-small">
    {{ errorMessage }}
  </p>
</div>
